module.exports = __webpack_public_path__ + "img/Menu-01.dc9c81a5.png";